import { useMutation } from '@tanstack/react-query';
import { getSearchDataFull } from '../../api/search/getSearchDataFull';

export const useGetSearchDataFull = () => {
  const { data, isSuccess, mutate, isPending } = useMutation({
    mutationKey: ['getSearchDataFull'],
    mutationFn: ({
      search,
      params,
    }: {
      search: string;
      params?: Record<string, string | number>;
    }) => getSearchDataFull(search, params),
  });

  return {
    searchDataFullMutate: mutate,
    searchDataFull: data,
    isGetSearchDataFullSuccess: isSuccess,
    isGetSearchDataFullPending: isPending,
  };
};
